import { cn } from 'cn';
import { useTranslation } from 'react-i18next';

import { useQueryAnalyticsKpi } from '~/data/analytics';

import { i18n } from '~/utils';

import { withErrorBoundary } from '@vestigas/ui';

import { getKpiProps, useDateRange } from '../utils';

import { KPI } from './KPI';

/**
 * KpiDeliveryNotesReceived
 *
 * Displays the number of received delivery notes for the selected date range.
 */
export const KpiDeliveryNotesReceived = withErrorBoundary(
  ({ className, style }: ComponentStyling) => {
    const { t } = useTranslation('analytics');

    const dateRange = useDateRange();

    const { data, isFetching } = useQueryAnalyticsKpi({
      dateRange,
      kpiName: 'total_dlns',
    });

    const kpi = getKpiProps({
      iconMetaphor: 'deliveryNote',
      kpiColor: 'text-green-700',
      label: t(($) => $.usage.deliveryNotes.received),
      previousValue: data?.previousValue,
      tooltip: t(($) => $.usage.deliveryNotes.receivedTooltip),
      value: data?.value,
    });

    return (
      <KPI
        className={cn(
          'rounded-lg border border-green-300 bg-green-100 p-4',
          className,
        )}
        style={style}
        isLoading={isFetching}
        {...kpi}
      />
    );
  },
  i18n.t(($) => $.errorBoundary.fallbackMessage, {
    ns: 'analytics',
    section: i18n.t(($) => $.usage.deliveryNotes.received, { ns: 'analytics' }),
  }),
);

KpiDeliveryNotesReceived.displayName = 'KpiDeliveryNotesReceived';
